import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import ContactUs from "./sections/ContactUs";
import OurNeighborhood from "./sections/OurNeighborhood";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <ContactUs />
      <OurNeighborhood />
      <Footer />
    </div>;
}